import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Info, Wheelchair } from '@zocdoc/components/src/icons';
import { grey } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Tooltip, TOOLTIP } from '@zocdoc/components/src/Tooltip';
import { FontFamily } from '@zocdoc/components/src/typography';

const TooltipIconWrapper = styled.div`
    display: inline-block;
    font-size: 12px;
    margin: -3px -6px 0 4px
`;

const TooltipTarget = styled.div`
    padding: 6px 6px 0;
`;

const StyledTooltip = styled(Tooltip)`
    text-align: left;
    white-space: pre-line;

    ${breakpoint.small} {
        font: 12px/20px ${FontFamily.KievitSlabBook};
        left: -112px;
        top: 36px;
        width: 250px;
    }

    ${breakpoint.medium} {
        font: 14px/20px ${FontFamily.KievitSlabBook};
    }
`;

class InfoTooltip extends PureComponent {
    static propTypes = {
        onDisplayTooltip: PropTypes.func,
        icon: PropTypes.string,
    }

    render() {
        const {
            children,
            alt,
            onDisplayTooltip,
            icon,
        } = this.props;

        let tooltipIcon = (
            <Info
                alt={alt}
                color={grey}
            />
        );
        if (icon && icon === 'wheelchair') {
            tooltipIcon = (
                <Wheelchair
                    alt={alt}
                    color={grey}
                />
            );
        }
        const anchor = <TooltipTarget>{tooltipIcon}</TooltipTarget>;
        return (
            <TooltipIconWrapper>
                <StyledTooltip
                    anchor={anchor}
                    onDisplayTooltip={onDisplayTooltip}
                    showTooltipOnFocus
                    showTooltipOnHover
                    tooltipPosition={TOOLTIP.BOTTOM}
                >
                    <span>{children}</span>
                </StyledTooltip>
            </TooltipIconWrapper>
        );
    }
}

export default InfoTooltip;
